<template>
  <div
    class="fixed-bg-base"
    :class="'fixed-bg-base--status' + fixedBgStatus"
  >
    <canvas></canvas>
  </div>

</template>

<script>
export default {
  name: "FixedBackground",
  data(){
    return {
      bgShapes: [
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          loaded: false,
          elm: null,
          src: '/static/img/common/background/bg_moya_p01.png',
        },
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          elm: null,
          loaded: false,
          src: '/static/img/common/background/bg_moya_p02.png',
        },
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          elm: null,
          loaded: false,
          src: '/static/img/common/background/bg_moya_p03.png',
        },
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          elm: null,
          loaded: false,
          src: '/static/img/common/background/bg_moya_p04.png',
        },
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          elm: null,
          loaded: false,
          src: '/static/img/common/background/bg_moya_p05.png',
        },
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          elm: null,
          loaded: false,
          src: '/static/img/common/background/bg_moya_p06.png',
        },
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          elm: null,
          loaded: false,
          src: '/static/img/common/background/bg_moya_p07.png',
        },
        {
          width: 0,
          height: 0,
          naturalWidth: 0,
          naturalHeight: 0,
          elm: null,
          loaded: false,
          src: '/static/img/common/background/bg_moya_p08.png',
        },
      ],
      canvas: null,
      ctx: null,
      coefficient: 0.2,
      loadCnt: 0
    }
  },
  props: {
    allHeight: {
      type: Number,
      default() {
        return 0
      }
    },
    scrollPosition: {
      type: Number,
      default() {
        return 0
      }
    },
    fixedBgStatus: {
      type: Number,
      default: 1
    }
  },
  watch: {
    scrollPosition(val) {
      this.ctx.clearRect(0,0, this.canvas.width, this.canvas.height)
      this.drawAllShapes()
    }
  },
  mounted() {
    this.canvas = this.$el.querySelector('canvas')
    this.canvas.width = window.innerWidth
    this.canvas.height = window.outerHeight
    this.ctx = this.canvas.getContext('2d')
    this.loadCnt = 0
    for( let [ index, item ] of this.bgShapes.entries() ) {
      item.elm = document.createElement('img')
      item.elm.dataset.idx = index
      item.elm.addEventListener('load', this.onImgLoaded)
      item.elm.src = item.src
    }
  },
  methods: {
    onImgLoaded(e){
      this.loadCnt++
      const tgt = this.bgShapes[e.target.dataset.idx]
      tgt.naturalWidth = e.target.naturalWidth
      tgt.naturalHeight = e.target.naturalHeight
      tgt.width = window.innerWidth > 580 ? 580 : window.innerWidth
      tgt.height = tgt.naturalHeight * tgt.width / tgt.naturalWidth
      if(this.loadCnt >= this.bgShapes.length){
        this.onImgLoadComplete()
      }
    },
    drawAllShapes() {
      let pos = -( this.scrollPosition * this.coefficient )
      this.ctx.globalAlpha = 0.3
      for( let [ index, item ] of this.bgShapes.entries() ) {
        this.ctx.drawImage(item.elm, 0, pos, item.width, item.height)
        pos += item.height + 100
      }
      this.ctx.globalAlpha = 1
    },
    onImgLoadComplete() {
      this.drawAllShapes()
      setTimeout(()=>{
        this.canvas.classList.add('visible')
      },300)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.fixed-bg-base {
  width: 100vw;
  height: 100vh;
  position: fixed;
  /*background: url('~assets/images/storemock/background/bg_moya1.svg');*/
  top: 0;
  left: 0;
  z-index: -1;
  &--status1 {
    height: auto;
    background: url('/static/img/common/background/bg_def_moya1.jpg') no-repeat,
                url('/static/img/common/background/bg_def_moya2.jpg') no-repeat;
    background-size: 375px auto, 375px auto;
    background-position: 0 24px, 100% calc(100% - 20px);
    background-color: #fff;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 580px;
    margin: auto;
    canvas {
      display: none;
    }
  }
  &--status2 {
    width: 100%;
    max-width: 580px;
    left: 0;
    right: 0;
    margin: auto;
    background: $col_white;
  }
  canvas {
    opacity: 0;
    transition: opacity 500ms ease-out 0s;
    /*filter: opacity(0.8);*/
    &.visible {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/FixedBackground.vue